<template>
	<div class="golf">
		<div class="golf-test" :style="backgroundUrl">
			<div class="golf-test-title">{{golfTitle}}</div>
			<div class="golf-test-message">{{golfMessage}}</div>
		</div>
		<div class="golf-test-two" :style="backgroundUrlBottom">
			<div class="test-two-title">{{golfCoo}}</div>
			<div class="test-two-message1">{{golfcoo1}}</div>
			<div class="test-two-message" v-html="CooMessage">{{CooMessage}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'golf',
		data() {
			return {
				golfTitle: '乐范理念',
				golfMessage: '乐范健康科技有限公司是移动健康领域一家新晋的品牌。以“让按摩变得简单”为公司理念，致力于以高性价比的追求，为广大消费者打造优质的便携移动按摩产品。在社会快速发展，生活压力和工作压力都成倍增长的时代背景下，让年轻人正承受着远高于父辈的压力，难以协调工作与私人时间的矛盾，无法让疲惫的身体得到放松成为当下年轻人亚健康状态的主要原因之一。乐范敏锐的察觉到这一点，将按摩产品年轻化，碎片化，私属化，告别传统按摩器具的笨重，重新定义移动健康。让忙于工作的年轻人也能体会到按摩放松的舒适与乐趣。',
				golfcoo1: '',
				golfCoo: '乐范创始人 戴冬英',
				CooMessage: '戴冬英,英文名Helen,厦门创新协会成员,吴晓波频道新匠人学院福建分会共治会副会长,在大健康产业供应链管理及制造资源领域深耕超过十年,2017年创办乐范,正式进军移动健康领域</br> 2003年10月-2012年6月——在蒙发利（现奥佳华集团） 负责组建电子厂、箱包厂,PMC团队,在采购、工艺、生产制造等供应链管理方面积累了多年经验<br> 2012年6月－2016年12月—— 成立全新事业部, 组建团队运营美国品牌Jam蓝牙音箱,成功打通国内销售通路,取得不小的成绩,四年的沉淀不但在销售渠道方面积累了势能,还培养出一批能打能抗的运营团队。</br>2017年2月——觉得时机已经成熟的戴冬英正式进军移动健康领域,带领团队打造首款爆品魔力贴,这款号称“口袋里的按摩师” 的按摩贴,可以说是国内首款大规模销售的低频类按摩产品,出货量已超过100万。</br>2018年——已经推出多款爆品的乐范凭借实力被更多人看见,戴冬英也进入了吴晓波频道举办的2018年度新匠人100榜单,成为极具潜力新国货代表的品牌掌门人',
				backgroundUrl: 'background-image: url(' + this.GLOBAL.imgHost + '/images/about/background1.png);',
				backgroundUrlBottom: 'background-image: url(' + this.GLOBAL.imgHost + '/images/about/coo2.png);'
			}
		},


	}
</script>

<style scoped>
	.golf {
		padding-right: 250px;
		max-width: 1024px;
		margin: 0 auto;
		margin-top: 100px;
	}

	.golf-test {


		background-size: 100% auto;
		padding-top: 40px;
		padding-bottom: 60px;
	}

	.golf .golf-test .golf-test-title {
		width: 120px;
		margin-left: 53px;
		font-size: 18px;
		font-family: Alibaba PuHuiTi-M;
		font-weight: 650;
		color: rgba(255, 255, 255, 1);
		line-height: 53px;
		text-align: left;

	}

	.golf .golf-test .golf-test-message {
		margin-top: 30px;
		margin-left: 53px;
		margin-right: 330px;
		width: 637px;
		font-size: 13px;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		line-height: 38px;
		text-align: left
	}

	.golf-test-two {
		padding-bottom: 30px;

		margin-bottom: 150px;
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
		position: relative;
		bottom: -20px;
		z-index: 90;
		padding-top: 20px;
	}

	.golf-test-two .test-two-title {
		width: 269px;
		font-size: 18px;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 550;
		color: rgba(255, 255, 255, 1);
		line-height: 53px;
		margin-left: 53px;
		text-align: left;
	}

	.golf-test-two .test-two-message1 {
		width: 269px;
		margin-left: 53px;
		font-size: 12px;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		line-height: 36px;
		text-align: left
	}

	.golf-test-two .test-two-message {

		width: 637px;
		margin-left: 53px;
		font-size: 13px;

		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		line-height: 36px;
		text-align: left
	}
</style>
